module.exports = __webpack_public_path__ + "static/media/travesseiroqp.3f1653a4.webp";